import type { XYSeries } from "@amcharts/amcharts4/charts";
import { TaxonomyMainCategories, Taxonomy } from "@common/categories";
import { Category } from "@common/types/category";
import { getMainCategory } from "@common/helpers/taxonomy";
import { isUUID } from "@common/helpers/uuid";
import type { AmchartsModules } from "@lib/loaders/amchartsLoader";
import { ChartDataSeriesItem } from "../types";

interface ApplySeriesColorParams {
    item: ChartDataSeriesItem;
    series: XYSeries;
    categoriesById: Record<string, Category>;
    amcharts: AmchartsModules;
}

const CATEGORY_COLOR_MAP: Record<TaxonomyMainCategories, string> = {
    [Taxonomy.income]: "#68C7FF",
    [Taxonomy.uncategorized]: "#CCC",
    [Taxonomy.auto_vehicle]: "#C1CDD1",
    [Taxonomy.repairs_maintenance]: "#B8D0DD",
    [Taxonomy.donations]: "#93C2D8",
    [Taxonomy.insurance]: "#A4BDE9",
    [Taxonomy.personal]: "#7CAAFB",
    [Taxonomy.travel]: "#8589F8",
    [Taxonomy.transfer]: "#BE97D1",
    [Taxonomy.contributions_distributions]: "#BE97D1",
    [Taxonomy.legal_professional]: "#A4A7E4",
    [Taxonomy.supplies_equipment]: "#CBABAB",
    [Taxonomy.health_dental]: "#EE85D0",
    [Taxonomy.entertainment]: "#D87DE7",
    [Taxonomy.software_subscriptions]: "#C48CFF",
    [Taxonomy.advertising_marketing]: "#FF779A",
    [Taxonomy.taxes]: "#F97C7C",
    [Taxonomy.credit_card_loans]: "#FF897E",
    [Taxonomy.meals]: "#FFAD77",
    [Taxonomy.fees]: "#FFD27E",
    [Taxonomy.rentals_leases]: "#F0D26E",
    [Taxonomy.utilities]: "#E9E47C",
    [Taxonomy.communications]: "#C9E47B",
    [Taxonomy.retirement]: "#9AE981",
    [Taxonomy.payroll]: "#83E4B1",
    [Taxonomy.learning_development]: "#7DE5E3",
    [Taxonomy.security_deposit]: "#E58181",
    [Taxonomy.cogs]: "#B3E1E0",
    [Taxonomy.business_office]: "#F0D26E",
    [Taxonomy.charitable_contributions]: "#D5B29F",
    [Taxonomy.assets]: "#9AE981",
};

function isValidTaxonomyWithAssignedColor(
    value: string,
): value is TaxonomyMainCategories {
    return Object.keys(CATEGORY_COLOR_MAP).includes(value);
}

export function applySeriesColor({
    item,
    series,
    categoriesById,
    amcharts,
}: ApplySeriesColorParams) {
    const { am4core } = amcharts;
    let category: Category | undefined = undefined;
    if (isUUID(item.label)) {
        category = getMainCategory(item.label, categoriesById);
    } else if (item.parentCategory && isUUID(item.parentCategory)) {
        category = getMainCategory(item.parentCategory, categoriesById);
    }
    if (category && isValidTaxonomyWithAssignedColor(category.taxonomy)) {
        series.fill = am4core.color(CATEGORY_COLOR_MAP[category.taxonomy]);
    }
    series.stroke = am4core.color("#fff");
}
